<mat-card style="margin-top:30px;margin-left:10px;margin-right:30px;width:96%;height:100%;height:100%;min-height: 600px;">
    <div class="container-fluid">

   

        <div class="row" style="margin-top:10px;">
        </div>
        <hr/>

        <div class="row">
            <span style="margin-left:0px;margin-top:20px;"  class="lanai-page-title">Add Revenue Details</span>
            <p class="ace-heading-text-tabs-level-2" style="font-size:21px !important;">Calculate Rate</p>
        </div>
        <mat-radio-group aria-label="Select an option">
            <mat-radio-button value="0" checked="true" (click)="onSetTypeRevenueCalc('NET')">Net</mat-radio-button>
            <mat-radio-button value="1"  (click)="onSetTypeRevenueCalc('GROSS')">Gross</mat-radio-button>
        </mat-radio-group>

        <ng-container *ngIf="typeRevenueCalculation=='GROSS'">
            <p class="ace-heading-text-tabs-level-2" style="font-size:21px !important;">Calculate by Entering Gross Rate</p>
            <div class="row" style="margin-top:20px;">
                <div class="col-1">
                    <button mat-icon-button class="mt-0 ml-2" (click)="onResetAddRevenueDataGross()" stye="width:90%;" matTooltip="Reset Revenue Details">
                        <mat-icon style="margin-left:2px;color:black;" >restart_alt</mat-icon>
                       
                    </button>
                </div>
                <div class="col-2">
                    <mat-form-field appearance="fill" style="width:100%;color:gray">
                        <mat-label>Revenue Type*</mat-label>
                        <mat-select (selectionChange)="onChangeResetRevenueDataGross()" [(ngModel)]="revenueCodeSelectedGross" >
                          <mat-option value="">Select Revenue Type</mat-option>
                          <mat-option *ngFor="let revenueType of revenueTypes" [value]="revenueType.code" >
                            {{revenueType.description}}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                </div>
                <div class="col-1">
                    <div style="margin-top:15px;">
                        <div *ngIf="activeTaxListForLot.length > 0">
                            <input class="form-check-input" type="checkbox" value="" id="flexCheckCheckedGross" [(ngModel)]="addRevenueIsTaxableCheckBoxGross" checked (change)="confirmChangeTaxesFromAddedRevenue()" [disabled]="isTaxCheckboxReadOnly">
                            <label class="form-check-label" for="flexCheckCheckedGross" style="margin-left:2px;font-size:14px;">
                                Tax Applied
                            </label>
                        </div>
                    </div>
                </div>
                <div class="col-2">
                    <mat-form-field appearance="fill" style="width:100%;font-size:12px;">
                        <mat-label>Enter Gross Rate*</mat-label>
                        <input id="grossRatex" 
                        type="text"
                        (blur)="onCalculateRateFromGrossRate()" 
                        [(ngModel)]="grossRate"
                        twoDigitDecimaNumberDirective
                            matInput placeholder="Rate"
                            onfocus="this.select()"
                            />
                      </mat-form-field>
                </div>
                <div class="col-2" style="font-size:12px;">
                    <mat-form-field appearance="fill" style="width:100%;font-size:12px;">
                        <mat-label>Quantity*</mat-label>
                        <input id="quantityForGross" 
                        [(ngModel)]="grossQuantity"
                            matInput placeholder="Quantity"
                            aceNumericOnly
                            onfocus="this.select()"
                            (blur)="onCalculateRateFromGrossRate()">
                      </mat-form-field>
                </div>
                <div class="col-4">
                    <mat-form-field appearance="fill" style="width:100%;font-size:12px;">
                        <mat-label>Description*</mat-label>
                        <input matInput placeholder="Description" id="revenueDescription" [(ngModel)]="revenueDescriptionGross" (keyup)="isRevenueDataValidated()" maxlength="500" style="font-size:14px;">
                      </mat-form-field>
                </div>
            </div>
            <div class="row" style="margin-top:0px;">
                <div class="col-1" style="font-size:18px;"><strong>Gross Results:</strong></div>
                <div class="col-2" style="font-size:14px;">
                    <mat-form-field appearance="outline" style="width:100%;color:gray">
                        <mat-label>Rate</mat-label>
                        <input matInput placeholder="Rate" [ngModel]="netRate | currency" readonly="true">
                      </mat-form-field>
                </div>
                <div class="col-2" style="font-size:14px;">
                    <mat-form-field appearance="outline" style="width:100%;color:gray">
                        <mat-label>Tax Rate %</mat-label>
                        <input matInput placeholder="Tax Rate" [ngModel]="(grossTotalTaxRate) | percent:'2.2-2'" readonly="true">
                      </mat-form-field>
                </div>
                <div class="col-2" style="font-size:14px;">
                    <mat-form-field appearance="outline" style="width:100%;color:gray">
                        <mat-label>Total Net</mat-label>
                        <input matInput placeholder="Tax Rate" [ngModel]="grossDisplayNet | currency" readonly="true">
                      </mat-form-field>
                </div>
                <div class="col-2" style="font-size:14px;">
                    <mat-form-field appearance="outline" style="width:100%;color:gray">
                        <mat-label>Tax</mat-label>
                        <input matInput placeholder="Tax" [ngModel]="grossDisplayTaxAmount | currency" readonly="true">
                      </mat-form-field>
                </div>
                
                <div class="col-2" style="font-size:14px;">
                    <mat-form-field appearance="outline" style="width:100%;color:gray">
                        <mat-label>Total Gross</mat-label>
                        <input matInput placeholder="Tax" [ngModel]="grossDisplayAmount | currency" readonly="true">
                      </mat-form-field>
                </div>
                <div class="col-1" style="font-size:12px;">
                    <button class="btn btn-primary btn-sm ace-blue" style="margin-left:20px;margin-top:20px;" (click)="onSubmitAddedRevenue()" [disabled]="!inputValidatedGross">Submit</button>
                </div>
              
            </div>

            <hr/>
        </ng-container>

        <ng-container *ngIf="typeRevenueCalculation=='NET'">
            <p class="ace-heading-text-tabs-level-2" style="font-size:21px !important;">Calculate by Entering Net Rate</p>
            <div class="row" style="margin-top:0px;">
                <div class="col-1">
                    <button mat-icon-button class="mt-0 ml-2" (click)="onResetAddRevenueDataNet()"  stye="width:90%;" matTooltip="Reset Revenue Details">
                        <mat-icon style="margin-left:2px;color:black" >restart_alt</mat-icon>
                    </button>
                </div>
                <div class="col-2">
                  <mat-form-field appearance="fill" style="width:100%;color:gray">
                    <mat-label>Revenue Type*</mat-label>
                    <mat-select (selectionChange)="onChangeResetRevenueData()" id="revenueTypeNet" [(ngModel)]="revenueCodeSelectedNet">
                      <mat-option value="">Select Revenue Type</mat-option>
                      <mat-option *ngFor="let revenueType of revenueTypes" [value]="revenueType.code" >
                        {{revenueType.description}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div class="col-1">
                    <div style="margin-top:15px;">
                        <div *ngIf="activeTaxListForLot.length > 0">
                            <input class="form-check-input" type="checkbox" value="" id="flexCheckCheckedNet" [(ngModel)]="addRevenueIsTaxableCheckBoxNet" checked (change)="confirmChangeTaxesFromAddedRevenue()" [disabled]="isTaxCheckboxReadOnly">
                            <label class="form-check-label" for="flexCheckCheckedNet" style="margin-left:2px;font-size:11px;">
                                Tax Applied
                            </label>
                        </div>
                    </div>
                </div>
                <div class="col-2">
                    <mat-form-field appearance="fill" style="width:100%;font-size:12px;">
                        <mat-label>Enter Net Rate*</mat-label>
                        <input id="netRatex" 
                        [(ngModel)]="netRateValue"
                            matInput placeholder="Rate"
                            twoDigitDecimaNumberDirective
                            onfocus="this.select()"
                        (blur)="onCalculateRateFromNetRate()" >
                      </mat-form-field>
                </div>
                    <div class="col-2" style="font-size:12px;">
                        <mat-form-field appearance="fill" style="width:100%;font-size:12px;">
                            <mat-label>Quantity*</mat-label>
                            <input id="quantityForGross" 
                            [(ngModel)]="netQuantity"
                            aceNumericOnly
                                matInput placeholder="Quantity"
                                onfocus="this.select()"
                                (blur)="onCalculateRateFromNetRate()">
                        </mat-form-field>
                    </div>
                    <div class="col-4">
                        <mat-form-field appearance="fill" style="width:100%;font-size:12px;">
                            <mat-label>Description*</mat-label>
                            <input matInput placeholder="Description" id="revenueDescription" [(ngModel)]="revenueDescriptionNet" (keyup)="isRevenueDataValidated()" maxlength="500">
                        </mat-form-field>
                    </div>

                  
            </div>
            <div class="row" style="margin-top:0px;margin-bottom:20px;">
                <div class="col-1" style="font-size:18px;"><strong>Net Results:</strong></div>
                <div class="col-2" style="font-size:16px;">
                      <mat-form-field appearance="outline" style="width:100%;color:gray">
                        <mat-label>Rate</mat-label>
                        <input matInput placeholder="Rate" [ngModel]="netRateValue | currency" readonly="true">
                      </mat-form-field>
                </div>
                <div class="col-2" style="font-size:16px;">
                        <mat-form-field appearance="outline" style="width:100%;color:gray">
                          <mat-label>Tax Rate %</mat-label>
                          <input matInput placeholder="Tax Rate" [ngModel]="(grossTotalTaxRate * 100) | number: '1.2-2'" readonly="true">
                        </mat-form-field>
                </div>
                <div class="col-2" style="font-size:14px;">
                    <mat-form-field appearance="outline" style="width:100%;color:gray">
                        <mat-label>Total Net</mat-label>
                        <input matInput placeholder="Tax Rate" [ngModel]="netDisplayTotalNet | currency" readonly="true">
                      </mat-form-field>
                </div>
                <div class="col-2" style="font-size:14px;">
                    <mat-form-field appearance="outline" style="width:100%;color:gray">
                        <mat-label>Tax</mat-label>
                        <input matInput placeholder="Tax" [ngModel]="netDisplayTaxAmount | currency" readonly="true">
                      </mat-form-field>
                </div>
                <div class="col-2" style="font-size:14px;">
                    <mat-form-field appearance="outline" style="width:100%;color:gray">
                        <mat-label>Total Gross</mat-label>
                        <input matInput placeholder="Tax" [ngModel]="netDisplayTotalAmount | currency" readonly="true">
                      </mat-form-field>
                </div>
                <div class="col-1" style="font-size:12px;">
                    <button class="btn btn-primary btn-sm ace-blue" style="margin-left:20px;margin-top:20px;" (click)="onSubmitAddedRevenue()" [disabled]="!inputValidatedNet">Submit</button>
                </div>
            </div>

            <hr/>
        </ng-container>
       

        <!-- <div class="row mt-4" >
            <div class="col-12">
                <strong>Add Revenue Details</strong>
            </div>
        </div>
       

        
        
        <div class="row" style="margin-top:10px;margin-left:10px;margin-right:10px;">
            <div class="col-1">
                <button mat-icon-button class="mt-0 ml-2" >
                    <mat-icon style="margin-left:2px;color:black" >restart_alt</mat-icon>
                    Reset
                </button>
            </div>
            <div class="col-2">
                <select id="revenueType"  class="form-select" 
                    aria-label="Default select example" 
                    style="font-size:12px;width:225px;margin-right:5px;margin-top:7px;" 
                    (change)="onChangeResetRevenueData()" >
                    <option  [value]="0" >
                        -- SELECT REVENUE TYPE --
                    </option>
                    <option *ngFor="let revenueType of revenueTypes" [value]="revenueType.code" >
                        {{revenueType.description}}
                    </option>
                  </select>
                 
            </div>
            <div class="col-1">
                <mat-form-field appearance="fill" style="width:100%;font-size:12px;">
                    <mat-label>Rate</mat-label>
                    <input id="revenueRate" 
                    appNumericOnlyFourDecimal
                        matInput placeholder="Rate"
                        [(ngModel)]="currentRevenueRate"
                        (blur)="calculateTotalRevenue()"
                        onfocus="this.select()" >
                  </mat-form-field>
            </div>
            <div class="col-1">
                <mat-form-field appearance="fill" style="width:100%;font-size:12px;">
                    <mat-label>Quantity</mat-label>
                    <input id="revenueQuantity"
                    [(ngModel)]="addedRevenueQuantity"
                    type="number"
                        matInput placeholder="Quantity" 
                        (blur)="calculateTotalRevenue()"
                        onfocus="this.select()">
                  </mat-form-field>
            </div>

            <div class="col-1">
              
                <mat-form-field appearance="fill" style="width:100%;font-size:12px;">
                    <mat-label>Net</mat-label>
                    <input id="preTaxRevenueTotal"
                        matInput placeholder="Rate Subtotal" 
                        readonly
                        [(ngModel)]="subtotalCalcedAddedRevenue"
                        >
                  </mat-form-field>
            </div>
          
            <div class="col-1">
                <div style="margin-top:12px;">
                    <div *ngIf="activeTaxListForLot.length > 0">
                        <input class="form-check-input" type="checkbox" value="" id="flexCheckChecked" [(ngModel)]="addRevenueIsTaxableCheckBox" checked (change)="confirmChangeTaxesFromAddedRevenue()">
                        <label class="form-check-label" for="flexCheckChecked" style="margin-left:2px;font-size:11px;">
                            Tax Applied
                        </label>
                    </div>
                </div>
            </div>

            <div class="col-1">
             
                <mat-form-field appearance="fill" style="width:100%;font-size:12px;">
                    <mat-label>Gross</mat-label>
                    <input id="preTaxRevenueTotal"
                        matInput placeholder="Rate Total"
                        appNumericOnlyFourDecimal 
                        readonly
                        [(ngModel)]="totalCalcedAddedRevenue"
                        >
                  </mat-form-field>
            </div>

            <div class="col-3">
                <mat-form-field appearance="fill" style="width:100%;font-size:12px;">
                    <mat-label>Description</mat-label>
                    <input matInput placeholder="Description" id="revenueDescription" [(ngModel)]="revenueDescription" (keyup)="isRevenueDataValidated()" maxlength="500">
                  </mat-form-field>
            </div>

            <div class="col-1">
                    <button class="btn btn-primary btn-sm mt-2" style="margin-left:20px;" [disabled]="submitRevenueValidated" (click)="onSubmitAddedRevenue()" >Submit</button>
            </div>
        </div> -->
    

        <div class="row" style="margin-top:10px;margin-left:10px;margin-right:10px;">
            <div class="col-1">
              
            </div>
            <div class="col-2">
                 
            </div>
            <div class="col-1">
               <div *ngIf="addedRevenueValidation.rateAmountMessage !== ''">
                <span class="generic-error-presentation">{{addedRevenueValidation.rateAmountMessage}}</span>
               </div>
            </div>
            <div class="col-1">
                <div *ngIf="addedRevenueValidation.quantityMessage !== ''">
                    <span class="generic-error-presentation">{{addedRevenueValidation.quantityMessage}}</span>
                   </div>
            </div>

            <div class="col-1">
               
            </div>
          
            <div class="col-1">
                
            </div>

            <div class="col-1">
               
            </div>

            <div class="col-3">
                <div *ngIf="addedRevenueValidation.descriptionMessage !== ''">
                    <span class="generic-error-presentation">{{addedRevenueValidation.descriptionMessage}}</span>
                   </div>
            </div>

            <div class="col-1">
                   
            </div>
        </div>

        <div *ngIf="revenueBeingAdded" class="spinner-wrapper">
            <mat-spinner></mat-spinner>
        </div>


        <ng-container class="ml-4" *ngIf="appliedRevenue?.length">
            <strong style="font-size:14px;margin-left:20px;margin-top:30px;">Added Revenue Details</strong>
            <div class="mat-elevation-z8" style="margin-left:20px;margin-top:20px; margin-right:20px;" >
            <table style="width:100%;margin-left:2px;margin-right:2px;margin-top:10px;">
                <th style="font-size:12px;">
                    Date
                </th>
                <th style="font-size:12px;">
                    Revenue Type
                </th>
            
                <th style="font-size:12px;">
                    Rate
                </th>
                <th style="font-size:12px;">
                    Quantity
                </th>
                <th style="font-size:12px;">
                    Net
                </th>
                <th style="font-size:12px;">
                    Gross
                </th>
                <th style="font-size:12px;">
                    Description
                </th>
                <th style="font-size:12px;">
                    
                </th>
                
                <tr *ngFor="let revenueItem of appliedRevenue;let i = index">
                    <td style="font-size:12px;">
                        {{revenueItem.dateGenerated | date:'shortDate'}}
                    </td>
                    <td style="font-size:12px;">
                        {{revenueItem.revenueTypeName}}
                    </td>

                    <div *ngIf="revenueItem.billingRate < 0">
                        <td style="color:red;font-size:12px;">
                            {{revenueItem.billingRate |  currency}}
                        </td>
                    </div>

                    <div *ngIf="revenueItem.billingRate >= 0">
                        <td  style="color:black;font-size:12px;">
                            {{revenueItem.billingRate |  currency}}
                        </td>
                    </div>

                    <td style="font-size:12px;">
                        {{revenueItem.quantity}}
                    </td>
                    <td *ngIf="(revenueItem.billingRate * revenueItem.quantity) < 0" style="color:red;font-size:12px;">
                        {{(revenueItem.billingRate * revenueItem.quantity) | currency}}
                    </td>
                    <td *ngIf="(revenueItem.billingRate * revenueItem.quantity) >= 0" style="color:black;font-size:12px;">
                        {{(revenueItem.billingRate * revenueItem.quantity) | currency}}
                    </td>
                    <td style="font-size:12px;">
                        {{((revenueItem.billingRate * revenueItem.quantity)) + revenueItem.tax | currency}}
                    </td>
                    <td style="font-size:12px;">
                        {{revenueItem.description }}
                    </td>
                    <td style="font-size:11px;">
                        <div *ngIf="revenueItem.adjust === 0">
                            <button type="button" class="btn btn-link" style="font-size:12px;margin-top:-2px" (click)="onShowRevenuePostAdjustment(revenueItem.revenueAdjustmentId)" >Adjust</button>
                        </div>
                    </td>
                </tr>
            
            </table>   
            </div>
        </ng-container>

        <div *ngIf="showRevenuePostAdjustment" style="margin-left:15px;margin-top:30px;margin-bottom:20px;">
            <div class="row">
                <div class="col-2">
                    Adjustment Reason
                </div>
                <div class="col-2">
                   Gross Amount
                </div>
            </div>
            <div class="row">
                <div class="col-2">
                    <select id="revenuePostAdjustmentReason"  
                        class="form-select" 
                        aria-label="Default select example" 
                        style="font-size:12px;width:225px;margin-right:5px;margin-top:7px;" 
                        (change)="onRevenuePostAdjustmentReasonChange()"
                        >
                        <option  [value]="0" >
                            Select Adjustment Reason
                        </option>
                        <option *ngFor="let adjustmentReason of invoiceAdjustmentReasons" [value]="adjustmentReason.adjustmentReasonId" >
                            {{adjustmentReason.reason}}
                            </option>
                      </select>
                     
                </div>
                <div class="col-2">
                  <mat-form-field appearance="fill" style="width:100%;font-size:12px;color:red;">
                    <mat-label>Amount</mat-label>
                    <input matInput placeholder="Gross" 
                    id="amountRevenuePostAdjustment"
                    value={{revenuePostAdjustmentAmount}}
                    readonly
                    >
                  </mat-form-field>
                </div>
                <div class="col-2">
                    <button class="btn btn-light btn-sm" 
                        style="margin-left:20px;margin-right:5px;"
                        (click)="cancelRevenuePostAdjustmentSubmit()" >Cancel</button>
                    <button class="btn btn-primary btn-sm ace-blue" 
                        style="margin-left:20px;" 
                        (click)="onSubmitPostRevenueAdjustment()"
                        [disabled]="flagDisablePostRevenueAdjustmentButton">Submit</button>
                </div>
                                        </div>
            
        </div>

        <div *ngIf="appliedRevenue?.length">
                <div style="margin-top:30px;"></div>
        </div>

        <ng-container *ngIf="revenuePostAdjustments?.length === 0">
            <strong style="font-size:14px;margin-left:20px;">No Revenue Post Adjustments</strong>
        </ng-container>

        <ng-container class="ml-4" *ngIf="revenuePostAdjustments?.length" style="margin-top:50px;">
            <strong style="font-size:14px;margin-left:20px;">Post Revenue Adjustments</strong>
            <div class="mat-elevation-z8" style="margin-left:20px;margin-top:20px; margin-right:20px;" >
            <table style="width:100%;margin-left:2px;margin-right:2px;margin-top:10px;">
                <th style="font-size:12px;">
                    Date
                </th>
                <th style="font-size:12px;">
                    Revenue Type
                </th>
            
                <th style="font-size:12px;">
                    Net
                </th>
                <th style="font-size:12px;">
                    Tax
                </th>
                <th style="font-size:12px;">
                    Gross
                </th>
                <th style="font-size:12px;">
                    Description
                </th>
                
                <tr *ngFor="let revenueAdjustmentItem of revenuePostAdjustments;let i = index">
                    <td style="font-size:12px;">
                        {{revenueAdjustmentItem.dateEntered | date:'shortDate' }}
                    </td>
                    <td style="font-size:12px;">
                        {{revenueAdjustmentItem.revenueTypeDescription }}
                    </td>
                
                   
                    <td>
                        <div *ngIf="(revenueAdjustmentItem.adjustedAmount) < 0">
                            <span style="color:red;font-size:12px;">{{revenueAdjustmentItem.adjustedAmount |  currency}}</span>
                        </div>
                        <div *ngIf="(revenueAdjustmentItem.adjustedAmount) >= 0">
                            <span style="color:black;font-size:12px;">{{revenueAdjustmentItem.adjustedAmount |  currency}}</span>
                        </div>
                    </td>
                


                    
                    <td >
                        <div *ngIf="revenueAdjustmentItem.adjustedTaxAmount >= 0" >
                            <span style="color:black;font-size:12px;">{{revenueAdjustmentItem.adjustedTaxAmount | currency}}</span>
                        </div>
                        <div *ngIf="revenueAdjustmentItem.adjustedTaxAmount < 0" >
                            <span style="color:red;font-size:12px;">{{revenueAdjustmentItem.adjustedTaxAmount | currency}}</span>
                        </div>
                    </td>
                   

                    <!-- <div *ngIf="(revenueItem.adjustedTaxAmount) >= 0" style="color:black;font-size:12px;">
                        <td style="font-size:12px;">
                            {{revenueItem.adjustedTaxAmount | currency}}
                        </td>
                    </div> -->
                   
                    <td>
                        <div *ngIf="(revenueAdjustmentItem.adjustedAmount + revenueAdjustmentItem.adjustedTaxAmount) < 0" >
                            <span style="color:red;font-size:12px;">{{(revenueAdjustmentItem.adjustedAmount + revenueAdjustmentItem.adjustedTaxAmount) | currency}}</span>
                        </div>
                        <div *ngIf="(revenueAdjustmentItem.adjustedAmount + revenueAdjustmentItem.adjustedTaxAmount) >= 0" >
                            <span style="color:black;font-size:12px;">{{(revenueAdjustmentItem.adjustedAmount + revenueAdjustmentItem.adjustedTaxAmount) | currency}}</span>
                        </div>
                    </td>
                   
                
                  
                    <td style="font-size:12px;">
                        {{revenueAdjustmentItem.reason }}
                    </td>
                  
                </tr>
            
            </table>   
            </div>
        </ng-container>

    </div>
</mat-card>


